import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@marsidev/react-turnstile/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/checkbox/checkbox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/close-button/close-button.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/combobox/combobox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/data-interactive/data-interactive.js");
;
import(/* webpackMode: "eager", webpackExports: ["Description"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/description/description.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/dialog/dialog.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/field/field.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/fieldset/fieldset.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/input/input.js");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/label/label.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/legend/legend.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/listbox/listbox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/menu/menu.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/popover/popover.js");
;
import(/* webpackMode: "eager", webpackExports: ["Portal"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/portal/portal.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/radio-group/radio-group.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/select/select.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/switch/switch.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/tabs/tabs.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/textarea/textarea.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/components/transition/transition.js");
;
import(/* webpackMode: "eager", webpackExports: ["useClose"] */ "/vercel/path0/node_modules/@privy-io/react-auth/node_modules/@headlessui/react/dist/internal/close-provider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/dashboard/components/CollectorAvatars/wrapper.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostCardCollectButton"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/home/components/PostCardComponents/PostCardCollectButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/FeaturedPublications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/FeaturedPublicationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyWriteSection"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/WhyWrite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverPrefetchLink"] */ "/vercel/path0/packages/nextjs/app/ui/HoverPrefetchLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/packages/nextjs/components/sections/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/vercel/path0/packages/nextjs/components/sections/testimonials-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/vercel/path0/packages/nextjs/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselPrevious","CarouselNext","CarouselContent","CarouselItem"] */ "/vercel/path0/packages/nextjs/components/ui/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/public/publication/farcaster.png");
